<template>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'error'"
    v-bind:end_date="'2026-11-05T01:30:00'">
    Bonjour,<br />
    Dans le cadre d’une opération technique,
    <b
      >les espaces JINIUS seront temporairement indisponibles le mercredi 4
      novembre de 19h à 24h</b
    >. <br />Durant cette période, il ne sera pas possible d’accéder aux
    portails ni aux services associés. Le rétablissement du service est prévu
    <b>à partir de 01h30 .</b><br />
    Nous vous remercions pour votre compréhension et vous prions de nous excuser
    pour la gêne occasionnée.<br />
    L’équipe JINIUS
  </refonte-page-alert>
  <refonte-page-title v-bind:description_in_card="true">
    Bienvenue dans votre Espace Gestion JINIUS.
    <br /><br />
    Cet espace vous permet de trouver les informations relatives à vos
    inscriptions, commandes ainsi que les documents associés : conventions,
    factures, certificats.<br />L'écran d'accueil vous fournit la liste des
    actions que vous avez à faire.
    <div v-if="profile.participant">
      Pour accéder aux informations de vos formations, allez dans votre
      <router-link
        to="/inscription/accueil"
        class="text-refonte_blue-600 underline">
        Espace Participant</router-link
      >.
    </div>
  </refonte-page-title>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'news'">
    Retrouvez les procédures de gestion et les modalités de la
    <u>signature électronique</u> dans nos guides utilisateurs :
    <a
      v-bind:href="`${cdn_url}/aide-en-ligne/Guide-signature-elec.pdf`"
      class="alert-link"
      target="_blank"
      rel="noopener noreferrer">
      Conventions
    </a>
    et
    <a
      v-bind:href="`${cdn_url}/aide-en-ligne/050626_PIF__Espace-Gestion_Guide-signature-elec.pdf`"
      class="alert-link"
      target="_blank"
      rel="noopener noreferrer">
      Protocoles Individuels de Formation (PIF)</a
    >.
    <br />
  </refonte-page-alert>

  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconFormations"
    title="Inscriptions"
    v-bind:start_open="true">
    <div class="btn-dashboard-container">
      <template v-if="!inscriptionIndicateursLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/gestion/inscriptions?statutId=1&inscriptions=ACTIVES'
              )
          ">
          <b>{{ inscriptionIndicateurs.nombreInscriptionsEnAttente }}</b>
          inscription(s) sont en attente de confirmation par l'organisateur.
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/gestion/inscriptions?action=T_POS_NON_REALISE&inscriptions=ACTIVES'
              )
          ">
          <b>{{
            inscriptionIndicateurs.nombreInscriptionsTestsPositionnementNonRealise
          }}</b>
          participant(s) n'ont pas encore rempli leur test de positionnement.
          Ceci est nécessaire pour confirmer leur inscription.
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/gestion/inscriptions?action=CONVENTIONS_A_SIGNER&inscriptions=ACTIVES'
              )
          ">
          <b>{{
            inscriptionIndicateurs.nombreInscriptionsConventionsASigner
          }}</b>
          convention(s) / contrat(s) de formation sont en attente de signature.
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/gestion/inscriptions?action=PIF_A_SIGNER&inscriptions=ACTIVES'
              )
          ">
          <b>{{ inscriptionIndicateurs.nombreInscriptionsPifsASigner }}</b>
          PIF (Protocole Individuel de Formation) sont en attente de signature.
        </refonte-button>
        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/gestion/inscriptions')">
            Retrouvez vos inscriptions dans le menu « Inscriptions ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconFlagParcours"
    title="Sessions intra"
    v-if="hasSessionsIntra"
    v-bind:start_open="true">
    <div class="btn-dashboard-container">
      <template v-if="!indicateursLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () => router.push('/gestion/sessions?action=CONVENTIONS_A_SIGNER')
          ">
          <b>{{ indicateurs.nombreSessionsIntraConventionsASigner }}</b>
          session(s) avec convention(s) à signer.
        </refonte-button>

        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/gestion/sessions')">
            Retrouvez vos sessions intra dans le menu « Sessions intra ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconCommandes"
    title="Commandes"
    v-bind:start_open="true">
    <div class="btn-dashboard-container">
      <template v-if="!indicateursLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/gestion/commandes?commandeReglee=false&commandes=CONFIRMEES'
              )
          ">
          <b>{{ indicateurs.nombreCommandesNonReglees }}</b> commande(s) non
          réglée(s).
        </refonte-button>
        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/gestion/commandes')">
            Retrouvez vos commandes dans le menu « Commandes ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconTestPositionnement"
    v-if="hasContrats"
    title="Contrats Formateurs"
    v-bind:start_open="true">
    <div class="btn-dashboard-container">
      <template v-if="!indicateursLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="() => router.push('/gestion/contrats?statutId=1')">
          <b>{{ indicateurs.nombreContratsASigner }}</b> contrat(s) sont en
          attente de signature.
        </refonte-button>
        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/gestion/contrats')">
            Retrouvez vos contrats formateurs dans le menu « Contrats Formateurs
            ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconFactures"
    title="Factures"
    v-bind:start_open="true">
    <div class="btn-dashboard-container">
      <template v-if="!indicateursLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="() => router.push('/gestion/factures?typeIds=3')">
          Vous avez <b>{{ indicateurs.nombreFacturesARegler }}</b> facture(s)
          non acquittée(s).
        </refonte-button>
        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/gestion/factures')">
            Retrouvez toutes vos factures dans le menu « Factures ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
</template>
<script setup lang="ts">
  import RefontePageTitle from '@/components/refonte/titles/refonte-page-title.vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconCommandes from '@/assets/img/refonte/icons/menu/icon-orders.svg?component';
  import IconFactures from '@/assets/img/refonte/icons/menu/icon-bills.svg?component';
  import IconFormations from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import IconFlagParcours from '@/assets/img/refonte/icons/information/icon-flag-parcours.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';
  import { router } from '@/router';
  import { onMounted, ref, watch } from 'vue';
  import Spinner from '@/components/utils/spinner.vue';
  import IconTestPositionnement from '@/assets/img/refonte/icons/information/icon-test-positionnement.svg?component';
  import { storeToRefs } from 'pinia';
  import { useEntrepriseStore } from '@/stores/entreprise';
  import { Entreprise } from '@/types/gestion/entreprise';
  import { useAccueilFilterStore, useAccueilStore } from '@/stores/accueil';
  import { useRoute } from 'vue-router';
  import api_utils from '@/mixin/api_utils';
  import filters_utils from '@/mixin/utils/filters_utils';
  import { useAccountStore } from '@/stores/account';
  import RefontePageAlert from '@/components/refonte/alerts/refonte-page-alert.vue';
  import { map_domain_per_env } from '@/assets/data/data_maps';

  const indicateursLoading = ref(true);
  const inscriptionIndicateursLoading = ref(true);

  const hasContrats = ref<boolean>(false);
  const hasSessionsIntra = ref<boolean>(false);

  const accountStore = useAccountStore();
  const { profile } = storeToRefs(accountStore);

  const entrepriseStore = useEntrepriseStore();
  const { activeClientIds, activeEntrepriseIds, entreprises } =
    storeToRefs(entrepriseStore);

  const accueilStore = useAccueilStore();
  const { indicateurs, inscriptionIndicateurs } = storeToRefs(accueilStore);

  const accueilFilterStore = useAccueilFilterStore();
  const { filters } = storeToRefs(accueilFilterStore);

  const route = useRoute();

  const cdn_url = `https://cdn.${
    map_domain_per_env[import.meta.env.VITE_CONTEXT]
  }`;
  const fetchIndicateursData = async (query: any) => {
    indicateursLoading.value = true;
    await accueilStore.fetchIndicateurs(query);
    indicateursLoading.value = false;
  };

  const fetchInscriptionIndicateursData = async (query: any) => {
    inscriptionIndicateursLoading.value = true;
    await accueilStore.fetchInscriptionsIndicateurs(query);
    inscriptionIndicateursLoading.value = false;
  };

  const fetchData = async () => {
    let query: any = { ...route.query };

    if (activeClientIds.value && activeClientIds.value != '') {
      query = { ...query, clientIds: activeClientIds.value };
    }

    await Promise.allSettled([
      fetchIndicateursData(query),
      fetchInscriptionIndicateursData(query)
    ]);
  };

  const handleHasContrats = () => {
    hasContrats.value =
      (activeEntrepriseIds.value.length === 0 &&
        (entreprises.value as Entreprise[]).some((e) => e.hasContrats)) ||
      (activeEntrepriseIds.value.length > 0 &&
        (entreprises.value as Entreprise[])
          .filter((e) => activeEntrepriseIds.value.includes(e.entrepriseId))
          .some((e) => e.hasContrats));
  };

  const handleHasSessionsIntra = () => {
    hasSessionsIntra.value =
      (activeEntrepriseIds.value.length === 0 &&
        (entreprises.value as Entreprise[]).some((e) => e.hasSessionsIntra)) ||
      (activeEntrepriseIds.value.length > 0 &&
        (entreprises.value as Entreprise[])
          .filter((e) => activeEntrepriseIds.value.includes(e.entrepriseId))
          .some((e) => e.hasSessionsIntra));
  };

  watch(filters, async () => {
    let query: any = api_utils.methods.formatParams(filters.value, []);

    if (activeClientIds.value && activeClientIds.value != '') {
      query = { ...query, clientIds: activeClientIds.value };
    }

    if (!filters_utils.methods.isDeepEqual(query, route.query)) {
      await router.push({ query });
    }
  });

  watch(
    () => route.query,
    () => {
      fetchData();
    },
    { immediate: true }
  );

  watch(activeEntrepriseIds, () => {
    handleHasContrats();
    handleHasSessionsIntra();
  });

  onMounted(() => {
    accueilFilterStore.initFiltersFromQuery(route.query);
    handleHasContrats();
    handleHasSessionsIntra();
  });
</script>

<style lang="scss" scoped>
  .btn-dashboard-container {
    @apply flex flex-col;
    gap: 10px;
    padding: 2px 0 0 10px;

    .btn-dashboard {
      @apply w-full justify-between text-left text-refonte-black;
      max-width: 100% !important;

      b {
        @apply mr-1 text-refonte_blue-600;
      }
    }
    :deep(.refonte-btn.btn-secondary span) {
      overflow: initial;
      text-overflow: initial;
      display: initial;
      -webkit-box-orient: initial;
      -webkit-line-clamp: initial;
      font-size: 14px;
      font-weight: 400;
      line-height: 125%;
    }
  }
</style>
